jQuery(function ($) {
  // Check if window.zE exists
  if (window.zE && $("#zendesklauncher").length) {
    // Wait for the Zendesk Web Widget to be ready
    window.zE(() => {
      // Initially hide the Messenger
      zE("messenger", "close");

      // Variable to track the state of the Zendesk Messenger
      let isMessengerOpen = false;

      // Add click event listener to your custom button
      document
        .getElementById("zendesklauncher")
        .addEventListener("click", function () {
          // Toggle the Zendesk Messenger open/close
          if (isMessengerOpen) {
            // If the Messenger is open, close it
            zE("messenger", "close", () => {
              isMessengerOpen = false; // Update state after close
            });
          } else {
            // If the Messenger is closed, open it
            console.log("Zendesk launcher clicked");
            zE("messenger", "open", () => {
              isMessengerOpen = true; // Update state after open
            });
          }
        });
    });
  } else {
    console.log("Zendesk Web Widget (window.zE) is not available.");
  }
  $('a[href="#totop"]').click(function () {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  $(document).ready(function () {
    var homeSection = $(".home-section"),
      navbar = $(".navbar-custom"),
      navHeight = navbar.height(),
      width = Math.max($(window).width(), window.innerWidth),
      mobileTest;

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      mobileTest = true;
    }

    hoverDropdown(width, mobileTest);

    $(window).resize(function () {
      var width = Math.max($(window).width(), window.innerWidth);
      hoverDropdown(width, mobileTest);
    });

    /* ---------------------------------------------- /*
        * Navbar hover dropdown on desktop
        /* ---------------------------------------------- */

    function hoverDropdown(width, mobileTest) {
      if (width > 768 && mobileTest !== true) {
        $(
          ".navbar-custom .navbar-nav > li, .navbar-custom li.dropdown > ul > li"
        ).removeClass("open");
        var delay = 0;
        var setTimeoutConst;
        $(".navbar-custom .navbar-nav > li, .navbar-custom li > ul > li").hover(
          function () {
            var $this = $(this);
            setTimeoutConst = setTimeout(function () {
              $this.addClass("open");
              $this.find(".dropdown-toggle").addClass("disabled");
            }, delay);
          },
          function () {
            clearTimeout(setTimeoutConst);
            $(this).removeClass("open");
            $(this).find(".dropdown-toggle").removeClass("disabled");
          }
        );
      } else {
        $(
          ".navbar-custom .navbar-nav > li, .navbar-custom li > ul > li"
        ).unbind("mouseenter mouseleave");
        $(".navbar-custom [data-toggle=dropdown]")
          .not(".binded")
          .addClass("binded")
          .on("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).parent().siblings().removeClass("open");
            $(this)
              .parent()
              .siblings()
              .find("[data-toggle=dropdown]")
              .parent()
              .removeClass("open");
            $(this).parent().toggleClass("open");
          });
      }
    }

    /* ---------------------------------------------- /*
        * Navbar collapse on click
        /* ---------------------------------------------- */

    $(document).on("click", ".navbar-collapse.in", function (e) {
      if (
        $(e.target).is("a") &&
        $(e.target).attr("class") !== "dropdown-toggle" &&
        !$("body").hasClass("mega-menu-primary")
      ) {
        $(this).collapse("hide");
      }
    });

    /* ---------------------------------------------- /*
        * Set sections backgrounds
        /* ---------------------------------------------- */

    var module = $(".home-section, .module, .module-small, .side-image");
    module.each(function () {
      if ($(this).attr("data-background")) {
        $(this).css(
          "background-image",
          "url(" + $(this).attr("data-background") + ")"
        );
      }
    });

    /* ---------------------------------------------- /*
        * Open tabs by external link
        /* ---------------------------------------------- */

    $(".open-tab").click(function (e) {
      var pattern = /#.+/gi;
      var contentID = e.target.toString().match(pattern)[0];
      $('.nav-tabs a[href="' + contentID + '"]').tab("show");
    });

    /* ---------------------------------------------- /*
        * Scroll top
        /* ---------------------------------------------- */

    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $(".scroll-up").fadeIn();
      } else {
        $(".scroll-up").fadeOut();
      }
    });

    $('a[href="#totop"]').click(function () {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
    });

    /* ---------------------------------------------- /*
        * Dropdown mennu on tablet
        /* ---------------------------------------------- */

    var $menuBtnChildren = $(".menu-item-has-children"),
      submenuOpenClass = "open",
      $thisParent,
      $menuWrap = $(".header-menu-wrap");
    $menuBtnChildren.click(function (event) {
      if (
        mobileTest &&
        !$(this).hasClass(submenuOpenClass) &&
        window.innerWidth > 992
      ) {
        $thisParent = $(this).parent("ul").parent("li");
        if ($thisParent.hasClass(submenuOpenClass)) {
          $thisParent
            .find("." + submenuOpenClass)
            .removeClass(submenuOpenClass);
        } else {
          $menuWrap.find("." + submenuOpenClass).removeClass(submenuOpenClass);
        }
        $(this).addClass(submenuOpenClass);
        event.stopPropagation();
        return false;
      }
    });

    $("html,body,.main,.navbar-custom,.bottom-page-wrap").click(function () {
      $menuWrap.find("." + submenuOpenClass).removeClass(submenuOpenClass);
    });

    /* Visible arrow on mobile */
    if (
      mobileTest === true &&
      $(".flex-direction-nav").length > 0 &&
      $("ul.slides > li").length > 1
    ) {
      $(".flex-direction-nav").addClass("visible-arrow");
    }

    // Constants and Configurations
    const SELECTORS = {
      form: ".add_animal_form",
      birthDate: "#birth_date",
      petName: "#pet_name",
      healthIssues: ".select_pa_health_issues",
      animalType: 'input[name="animal_type"]',
      gender: 'input[name="gender"]',
      neutered: ".neutered_select",
      submitButton: 'button[name="save_animal_details"]',
      offcanvasAnimal: "#right-panel-addanimal",
      modalAddAnimal: "#modal-addanimal",
      animalsBlock: ".animals-block",
      deathButton: ".death-button-container",
      breedGroups: '[class*="_breed_group"]',
      breedSelects: ".breed_select",
      ownerNotification: ".owner-notification",
      ownerAlert: ".validation-warning",
      loaderForm: ".loader-animal-details",
      offcanvasOrder: "#right-panel-order",
      offcanavasProfile: "#right-panel-profile",
      offcanvasViewProfile: "#right-panel-viewprofile",
      animalSelectOrder: ".animal-select-order",
    };
    // Utility Functions
    const utils = {
      removeWarningMessages: () => $(".validation-warning").remove(),

      showLoadingState: () => {
        $(SELECTORS.animalsBlock).html(MESSAGES.loading);
      },

      hideLoadingState: () => {
        // Simple function to complement showLoadingState
        $(SELECTORS.animalsBlock).removeClass("loading");
      },
      refreshAnimalsBlock: () => {
        utils.showLoadingState();
        const url =
          window.location.protocol +
          "//" +
          window.location.hostname +
          "/account/dashboard/";
        $.ajax({
          url: url,
          type: "POST",
          data: { getAnimals: 1, ajax: 1 },
          success: function (dataofconfirm) {
            $(SELECTORS.animalsBlock)
              .removeClass("loading")
              .html(dataofconfirm.html);
            const targetHeight = $(SELECTORS.animalsBlock)[0].scrollHeight;
            $(SELECTORS.animalsBlock)[0].offsetHeight;
            $(SELECTORS.animalsBlock)
              .css("height", targetHeight + "px")
              .addClass("loaded");
          },
          error: function (dataofconfirm) {
            $(SELECTORS.animalsBlock)
              .removeClass("loading")
              .html(dataofconfirm.message)
              .addClass("loaded");
          },
        });
      },
      refreshLastOrdersTable: () => {
        if ($(".datatable_last_orders").length === 0) {
          return;
        }
        // Show a loading indicator in the orders table
        $(".datatable_last_orders").hide();
        $(".datatable-order-loader").show();

        const url =
          window.location.protocol +
          "//" +
          window.location.hostname +
          "/account/dashboard/";

        $.ajax({
          url: url,
          type: "GET",
          success: function (data) {
            // Extract the orders table content from the returned HTML
            const $returnedHtml = $(data);
            const $newOrdersTable = $returnedHtml.find(
              ".datatable_last_orders"
            );
            $(".datatable-order-loader").hide();
            if ($newOrdersTable.length) {
              // Replace the current orders table with the new one
              $(".datatable_last_orders").html($newOrdersTable.html()).show();
            }
          },
          error: function (xhr, status, error) {
            console.error("Error refreshing orders table:", error);
            $(SELECTORS.ownerNotification)
              .html(
                '<div class="bg-warning p-3 text-white fw-bold text-center">Une erreur est survenue lors de l\'actualisation. Veuillez rafraichir la page.</div>'
              )
              .show();

            setTimeout(() => {
              $(SELECTORS.ownerNotification).fadeOut().html("");
            }, 15000);
          },
        });
      },

      refreshOrderTable: () => {
        // Only proceed if we're on the orders page
        if ($(".datatable_order").length === 0) {
          return;
        }

        // Show loading indicator
        $(".datatable-order-container").hide();
        $(".datatable-order-loader").show();

        const url =
          window.location.protocol +
          "//" +
          window.location.hostname +
          "/account/order";

        // Function to handle column ordering based on screen width
        function handleColumnOrder(datatable) {
          if (window.innerWidth < 1200) {
            $(".total-amount").addClass("dt-right").removeClass("dt-left");
            datatable.colReorder.order([1, 0, 3, 2, 5, 4]);
          } else {
            $(".total-amount").removeClass("dt-right").addClass("dt-left");
            datatable.colReorder.reset();
          }
        }

        $.ajax({
          url: url,
          type: "GET",
          success: function (data) {
            // Extract the HTML from the response
            const $returnedHtml = $(data);
            const $newOrdersTable = $returnedHtml.find(".datatable_order");

            if ($newOrdersTable.length) {
              // First destroy existing DataTable instance
              if ($.fn.DataTable.isDataTable(".datatable_order")) {
                $(".datatable_order").DataTable().destroy();
              }

              // Replace the HTML content
              $(".datatable_order").html($newOrdersTable.html());

              // Reinitialize the DataTable with exact same configuration as original
              var datatable_order = new DataTable(".datatable_order", {
                language: {
                  paginate: {
                    next: "Suivante",
                    previous: "Précédente",
                  },
                },
                responsive: {
                  breakpoints: [
                    { name: "mobile", width: 768 },
                    { name: "tablet", width: 1200 },
                    { name: "desktop", width: Infinity },
                  ],
                  details: {
                    display: DataTable.Responsive.display.childRowImmediate,
                    target: "",
                    type: "none",
                  },
                },
                layout: {
                  bottomEnd: {
                    paging: {
                      firstLast: false,
                    },
                  },
                },
                fixedHeader: {
                  headerOffset: handleOffset(),
                },
                pageLength: 25,
                paging: true,
                searching: false,
                ordering: false,
                lengthChange: false,
                colReorder: true,
                info: false,
                columnDefs: [
                  { targets: [0, 1, 2, 3, 4], className: "dt-left" },
                  { targets: 5, className: "none" }, // Keep the "none" class for the last column
                ],
              });

              // Handle column order based on screen size
              handleColumnOrder(datatable_order);

              // Show the table container
              $(".datatable-order-loader").hide();
              $(".datatable-order-container").show();
            }
          },
          error: function (xhr, status, error) {
            console.error("Error refreshing orders datatable:", error);
            $(SELECTORS.ownerNotification)
              .html(
                '<div class="bg-warning p-3 text-white fw-bold text-center">Une erreur est survenue lors de l\'actualisation. Veuillez rafraichir la page.</div>'
              )
              .show();
            $(".datatable-order-loader").hide();
            $(".datatable-order-container").show();

            setTimeout(() => {
              $(SELECTORS.ownerNotification).fadeOut().html("");
            }, 15000);
          },
        });
      },
      validateForm: () => {
        const validations = [
          {
            condition: !$(SELECTORS.animalType + ":checked").length,
            message: MESSAGES.validationMessages.animalType,
          },
          {
            condition: !$(SELECTORS.gender + ":checked").length,
            message: MESSAGES.validationMessages.gender,
          },
          {
            condition: !$(SELECTORS.petName).val(),
            message: MESSAGES.validationMessages.name,
          },
          {
            condition: !$(SELECTORS.birthDate).val(),
            message: MESSAGES.validationMessages.birthDate,
          },
          {
            condition: !$(SELECTORS.neutered).val(),
            message: MESSAGES.validationMessages.neutered,
          },
        ];

        const warningMessages = validations
          .filter((v) => v.condition)
          .map(
            (v) => `
            <div class="bg-warning mb-3 validation-warning">
                <i class="fas fa-exclamation-triangle me-2"></i>${v.message}
            </div>
        `
          );

        return {
          isValid: !warningMessages.length,
          messages: warningMessages.join(""),
        };
      },
    };

    // Form Handlers
    const formHandlers = {
      loadAnimalDetails: ($element) => {
        // Get all data from element's data attributes

        const animal = {
          id: $element.data("animal-id"),
          type: $element.data("animal-type"),
          gender: $element.data("animal-gender"),
          name: $element.data("animal-name"),
          birth_date: $element.data("animal-birth-date"),
          health_issues: String($element.data("animal-health-issues")), // Explicitly convert to string
          neutered: $element.data("animal-neutered"),
          breed_id: $element.data("animal-breed-id"),
        };
        // Reset form state first
        $(".validation-warning").remove();

        // Reset mark-as-dead button state
        const $markAsDeadButton = $(".mark-as-dead");
        if ($markAsDeadButton.length) {
          // Reset button text and classes to default state
          $markAsDeadButton.html(`${animal.name} nous a quitté 😿`);
          $markAsDeadButton
            .removeClass("btn-danger text-white")
            .addClass("btn-gray text-dark");

          // Remove any cancel confirmation button
          $(".cancel-death-confirmation").remove();
        }

        // Set animal type (read-only)
        const typeInput = $(`${SELECTORS.animalType}[value="${animal.type}"]`);
        if (typeInput.length) {
          $(".type-option label").removeClass("active");
          typeInput.closest("label").addClass("active");
          typeInput.prop("checked", true).trigger("change");
          $(".type-option label").css("pointer-events", "none");
          $(SELECTORS.animalType).prop("disabled", true);
        }

        // Set gender (read-only)
        $(SELECTORS.gender).prop("disabled", true).prop("required", false);
        $(`${SELECTORS.gender}[value="${animal.gender}"]`).prop(
          "checked",
          true
        );
        $(SELECTORS.gender).closest("label").css("pointer-events", "none");

        // Set name (read-only)
        $(SELECTORS.petName)
          .val(animal.name)
          .prop("readonly", true)
          .prop("required", false);

        // Set birth date (read-only)
        $(SELECTORS.birthDate)
          .val(animal.birth_date)
          .prop("readonly", true)
          .prop("required", false)
          .css("pointer-events", "none");

        // Set health issues (editable)
        if ($(SELECTORS.healthIssues).length) {
          console.log($(animal.health_issues));

          // Ensure health_issues is a string and split it into an array
          let healthIssuesArray;
          if (typeof animal.health_issues === "string") {
            // Split health issues into an array
            healthIssuesArray = animal.health_issues
              .split(",")
              .map((item) => item.trim());
          } else {
            // Handle unexpected types
            console.error(
              "Unexpected type for animal.health_issues:",
              typeof animal.health_issues
            );
            healthIssuesArray = [];
          }

          $(SELECTORS.healthIssues)
            .val(healthIssuesArray) // Set the array of health issues
            .trigger("change"); // Trigger change to update select2
        }

        // Set neutered status (conditional disabled)
        const $neutered = $(SELECTORS.neutered);
        $neutered
          .val(animal.neutered)
          .prop("disabled", animal.neutered === 1)
          .prop("required", false);

        // Remove existing dselect wrapper if any
        const existingWrapper = $neutered[0].nextElementSibling;
        if (
          existingWrapper &&
          existingWrapper.classList.contains("dselect-wrapper")
        ) {
          existingWrapper.remove();
        }

        // Initialize dselect
        dselect($neutered[0], {
          search: false,
          clearable: false,
        });

        // Handle breed selection
        // First hide all breed groups and remove required
        $(SELECTORS.breedGroups).hide();
        $(SELECTORS.breedSelects)
          .prop("required", false)
          .prop("disabled", true)
          .each(function () {
            // Only initialize dselect if the select has options
            if (this.options && this.options.length > 0) {
              dselect(this, {
                search: true,
              });
            }
          });

        // Show and set the appropriate breed select
        if (animal.type && animal.type in breedsByType) {
          const breedSelect = $(`#${animal.type}_breed`);
          $(`.${animal.type}_breed_group`).show();

          breedSelect
            .val(animal.breed_id)
            .prop("disabled", true)
            .prop("required", true)
            .each(function () {
              // Only initialize dselect if the select has options
              if (this.options && this.options.length > 0) {
                dselect(this);
              }
            });
        }

        // Update form state and UI
        const titlePrefix = startsWithVowel(animal.name)
          ? "Informations d'"
          : "Informations de ";

        $(`${SELECTORS.offcanvasAnimal} h2`).text(titlePrefix + animal.name);

        // Update button state
        $(SELECTORS.submitButton)
          .text("Modifier")
          .removeClass("add_animal")
          .addClass("modify_animal");

        // Show death button with animal name
        $(SELECTORS.deathButton).show().find(".animal-name").text(animal.name);

        // Store animal ID in form data
        $(SELECTORS.form).data("animal-id", animal.id);

        // Optional: Add validation state classes
        $(".form-group").removeClass("has-error has-success");
      },
      resetForm: () => {
        // Detect context: check if modal is visible
        const isModalContext =
          $(SELECTORS.modalAddAnimal).is(":visible") ||
          $(SELECTORS.modalAddAnimal).hasClass("show");
        console.log("resetForm", isModalContext);

        if (isModalContext) {
          // Reset modal title
          $(SELECTORS.modalAddAnimal + " h2").text("Cet article est pour");
        } else {
          // Reset offcanvas title
          console.log("resetForm", $(SELECTORS.offcanvasAnimal + " h2"));
          $(SELECTORS.offcanvasAnimal + " h2").text("Ajouter un animal");
        }

        // Reset form
        $(SELECTORS.form)[0].reset();

        // Enable and reset all fields - use generic selectors for common elements
        $(SELECTORS.animalType).prop("disabled", false);
        $(SELECTORS.gender).prop("disabled", false);
        $(SELECTORS.petName).prop("readonly", false);

        // Reset birth date field for both contexts
        $(SELECTORS.birthDate)
          .prop("readonly", false)
          .prop("disabled", false)
          .css("pointer-events", "");

        // Reset pointer events
        $(".type-option label").css("pointer-events", "");
        $(SELECTORS.gender)
          .closest("label")
          .css("pointer-events", "")
          .prop("disabled", false);

        // Hide all breed groups
        $(SELECTORS.breedGroups).hide();
        // Reset all breed selects
        $(SELECTORS.breedSelects)
          .prop("required", false)
          .prop("disabled", false)
          .val("")
          .each(function () {
            // Only initialize dselect if the select has options
            if (this.options && this.options.length > 0) {
              dselect(this, {
                search: true,
              });
            }
          });

        // Reset neutered select for both contexts
        $(SELECTORS.neutered)
          .val(0)
          .prop("disabled", false)
          .each(function () {
            // Only initialize dselect if the select has options
            if (this.options && this.options.length > 0) {
              dselect(this);
            }
          });

        // Reset health issues for both contexts
        $(SELECTORS.healthIssues).val("").trigger("change");

        // Reset button text and state
        $(SELECTORS.submitButton)
          .text("Sauvegarder")
          .removeClass("modify_animal")
          .addClass("add_animal");

        // Hide death button
        $(SELECTORS.deathButton).hide();
        // Remove any stored animal ID
        $(SELECTORS.form).removeData("animal-id");

        // Reset animal type selection
        $(".type-option label").removeClass("active");

        // Reinitialize components (datepicker, etc.)
        initializeComponents();
      },
    };

    const MESSAGES = {
      loading:
        '<i class="fa-solid fa-circle-notch fa-spin fa-lg text-primary"></i>',
      errorLoading:
        '<div class="alert alert-danger">Erreur lors du chargement des animaux</div>',
      confirmDeath: (name) =>
        `Êtes-vous sûr de vouloir marquer ${name} comme décédé ?`,
      validationMessages: {
        animalType: "Veuillez sélectionner le type d'animal",
        gender: "Veuillez sélectionner le sexe de l'animal",
        name: "Veuillez saisir le nom de l'animal",
        birthDate: "Veuillez sélectionner la date de naissance",
        neutered: "Veuillez indiquer si l'animal est stérilisé",
        breedCat: "Veuillez sélectionner la race du chat",
        breedDog: "Veuillez sélectionner la race du chien",
      },
    };

    // Create a mapping of ongoing requests to prevent duplicates
    const animalFoodRequests = {};

    // Global variables for managing panel context
    let cameFromOrderPanel = false;
    let lastOrderPanelData = null;
    let sourceSelect2Info = null;
    // Global variables for managing cart modal context
    let cameFromCartSelect2 = false;
    let cartSelect2Info = null;

    /* Owner account */
    if ($(".profile-panel").length > 0) {
      const $profileContent = $("#profileContent").children().first();
      const $profilePanelDesktop = $("#profilePanelDesktop");
      const $profilePanelMobile = $("#profilePanelMobile");
      function moveContent() {
        if ($(window).width() >= 992) {
          $profileContent.appendTo($profilePanelDesktop);
        } else {
          $profileContent.appendTo($profilePanelMobile);
        }
      }

      // Move content on page load
      moveContent();

      // Move content when window is resized
      $(window).on("resize", function () {
        moveContent();
        $(SELECTORS.offcanavasProfile).offcanvas("hide");
      });
    }

    $(document).on("click", ".save_profile", function (e) {
      $(".alert-warning").remove();
      var btn = $(this);
      e.preventDefault();
      var first_name = $("#account_first_name").val();
      var last_name = $("#account_last_name").val();
      var user_email = $("#account_email").val();
      var user_birthday = $("#account_birthday").val();
      var user_address_1 = $("#account_address_1").val();
      var user_postcode = $("#account_postcode").val();
      var user_city = $("#account_city").val();
      var pwd = $("#password_current").val();
      var pwd_new = $("#password_1").val();
      var pwd_new2 = $("#password_2").val();
      console.log(first_name);
      console.log(last_name);
      console.log(user_email);
      console.log(user_birthday);
      console.log(user_address_1);
      console.log(user_postcode);
      console.log(user_city);
      console.log(pwd);
      console.log(pwd_new);
      console.log(pwd_new2);
      if (pwd.length > 0) {
        if (pwd_new !== pwd_new2) {
          $(this)
            .closest(".content-block")
            .prepend(
              "<div class='alert-warning p-4 mt-4 mb-4 '>Les deux nouveaux mots de passe ne correspondent pas.</div>"
            );
          return;
        }
        if (pwd_new.length == 0) {
          $(this)
            .closest(".content-block")
            .prepend(
              "<div class='alert-warning p-4 mt-4 mb-4 '>Le nouveau mot de passe ne peut pas être vide.</div>"
            );
          return;
        }
      }
      btn.html("Sauvegarde en cours");
      $.ajax({
        encoding: "UTF-8",
        data: {
          first_name: first_name,
          last_name: last_name,
          user_email: user_email,
          user_birthday: user_birthday,
          user_address_1: user_address_1,
          user_postcode: user_postcode,
          user_city: user_city,
          pwd: pwd,
          pwd_new: pwd_new,
          pwd_new2: pwd_new2,
          ajax: 1,
        },
        dataType: "json",
        type: "POST",
        success: function (dataofconfirm) {
          if (dataofconfirm == "pwd") {
            btn
              .closest(".content-block")
              .prepend(
                "<div class='alert-warning p-4 mt-4 mb-4 '>Votre mot de passe actuel n'est pas le bon, le mot de passe n'a pas pu être changé.</div>"
              );
            $("#right-panel").animate(
              {
                scrollTop: 0, // Scroll to the top
              },
              500
            );
          }
          if (dataofconfirm == "email") {
            btn
              .closest(".content-block")
              .prepend(
                "<div class='alert-warning p-4 mt-4 mb-4 '>Cet email est déjà utilisé par un autre utilisateur.</div>"
              );
            $("#right-panel").animate(
              {
                scrollTop: 0, // Scroll to the top
              },
              500
            );
          }
          if (dataofconfirm == "emailconfirm") {
            btn
              .closest(".content-block")
              .prepend(
                "<div class='alert-success p-4 mt-4 mb-4 '>Vous avez reçu un message sur " +
                  user_email +
                  " contenant un lien pour valider votre nouvel email.</div>"
              );
            $("#right-panel").animate(
              {
                scrollTop: 0, // Scroll to the top
              },
              500
            );
          }
          btn.html("Informatons mises à jour");
          setTimeout(function () {
            btn.html("Enregistrer les modifications");
          }, 2000);
        },
        error: function (f) {
          console.log("fail");
        },
      });
    });

    $(document).on("click", ".open-right-panel-order", function (e) {
      const $trigger = $(this);
      let $container;

      // Check if clicked element is a button (orders view) or row (dashboard view)
      if ($trigger.is("button")) {
        // In orders view, find the parent tr
        $container = $trigger.closest("tr");
      } else {
        // In dashboard view, the trigger is already the row
        $container = $trigger;
      }

      const order_header = $container.find(".order_header").html();
      const order_details = $container.find(".order_details").html();

      // Show offcanvas and set content
      $(SELECTORS.offcanvasOrder).offcanvas("show");
      $(`${SELECTORS.offcanvasOrder} .panel-header h2`).html(order_header);
      $(`${SELECTORS.offcanvasOrder} .panel-body`).html(order_details);

      // Initialize select2 on the original content
      initializeAnimalSelect2();

      zE("messenger:set", "zIndex", -1);
      zE("messenger", "close");
    });

    $(document).on("click", ".reorder-btn", function (e) {
      e.preventDefault();
      const $btn = $(this);
      const reorderUrl = $btn.data("reorder-url");

      // Disable button and show loading state
      $btn
        .prop("disabled", true)
        .addClass("bg-primary")
        .html('<i class="fa-solid fa-circle-notch fa-spin"></i> Re-commander');

      // Redirect to the add-to-cart URL
      window.location.href = reorderUrl;
    });

    // Handle select change without full refresh
    $(document).on("change", ".animal-select-order", function (e) {
      const $select = $(this);
      const selectedValues = $select.val() || [];
      const orderId = $select.data("order-id");
      const productId = $select.data("item-id");
      const $loader = $select.siblings(".animal-select-order-loader");

      // Determine if we're in the offcanvas or on the cart page
      const isInOffcanvas =
        $select.closest(SELECTORS.offcanvasOrder).length > 0;
      const isInCart =
        $select.closest(".woocommerce-cart").length > 0 ||
        $select.closest('[class*="cart"]').length > 0;

      // Create a unique key for this select
      const requestKey = orderId
        ? `${orderId}-${productId}`
        : `cart-${productId}`;

      // Clear any pending request for this select
      if (animalFoodRequests[requestKey]) {
        clearTimeout(animalFoodRequests[requestKey]);
      }

      // Show loader at the start
      $loader.removeClass("d-none").addClass("d-flex");

      // Handle "add_new" selection immediately
      if (selectedValues.includes("add_new")) {
        const previousSelections = selectedValues.filter(
          (value) => value !== "add_new"
        );
        $select.val(previousSelections).trigger("change.select2");

        // Store that we came from order panel and save the panel data (only if in offcanvas)
        if (isInOffcanvas) {
          cameFromOrderPanel = true;
          lastOrderPanelData = {
            header: $(`${SELECTORS.offcanvasOrder} .panel-header h2`).html(),
            body: $(`${SELECTORS.offcanvasOrder} .panel-body`).html(),
          };

          // Store the source Select2 information
          sourceSelect2Info = {
            orderId: orderId,
            productId: productId,
            currentSelections: previousSelections,
          };

          $(SELECTORS.offcanvasOrder).offcanvas("hide");
          setTimeout(() => {
            safelyDestroySelect2(".animal-select-order");
            formHandlers.resetForm();
            $(SELECTORS.offcanvasAnimal).offcanvas("show");
            zE("messenger:set", "zIndex", -1);
            zE("messenger", "close");
          }, 300);
        } else {
          // Handle add new animal on cart page using modal
          // Store that we came from cart Select2 and save the context
          cameFromCartSelect2 = true;
          cartSelect2Info = {
            productId: productId,
            currentSelections: previousSelections,
            selectElement: $select,
          };
          setTimeout(() => {
            formHandlers.resetForm();
            $(SELECTORS.modalAddAnimal).modal("show");
            zE("messenger:set", "zIndex", -1);
            zE("messenger", "close");
          }, 300);
        }

        $loader.removeClass("d-flex").addClass("d-none");
        return;
      }

      // Delay the AJAX request to allow multiple changes (including clearing) to complete
      animalFoodRequests[requestKey] = setTimeout(function () {
        // Get the current values (they might have changed since the event triggered)
        const validAnimals = ($select.val() || []).filter(
          (id) => id !== "add_new"
        );

        // Calculate share percentage
        const sharePercentage =
          validAnimals.length > 0 ? Math.floor(100 / validAnimals.length) : 100;

        // Determine the correct endpoint and data based on context
        let ajaxData, ajaxUrl;

        if (isInOffcanvas && orderId) {
          // Original offcanvas functionality
          ajaxUrl =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/account/dashboard/";
          ajaxData = {
            updateOrderAnimalAssignments: 1,
            ajax: 1,
            order_id: orderId,
            product_id: productId,
            animals: validAnimals,
            animal_share: sharePercentage,
          };
        } else if (isInCart) {
          // Cart page functionality - store in session for later
          ajaxUrl =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/boutique/wp-admin/admin-ajax.php";
          ajaxData = {
            action: "store_cart_animal_assignments",
            product_id: productId,
            animals: validAnimals,
            animal_share: sharePercentage,
            nonce: window.wc_cart_params
              ? window.wc_cart_params.custom_nonce
              : "",
          };
        } else {
          console.log("Context not recognized, skipping AJAX request");
          $loader.removeClass("d-flex").addClass("d-none");
          return;
        }

        // Send one request with the final state
        $.ajax({
          url: ajaxUrl,
          type: "POST",
          data: ajaxData,
          success: function (response) {
            if (response.success) {
              if (isInOffcanvas && orderId) {
                // Update in the original panel (hidden select) - original functionality
                const $originalSelect = $(
                  `.d-none.order_details .animal-select-order[data-order-id="${orderId}"][data-item-id="${productId}"]`
                );

                // First clear all selections
                $originalSelect.find("option").removeAttr("selected");

                // Then set selected attribute for valid animals
                validAnimals.forEach((value) => {
                  $originalSelect
                    .find(`option[value="${value}"]`)
                    .attr("selected", "selected");
                });

                // Force a val() update as well
                $originalSelect.val(validAnimals);

                // If the server returned updated animal names, update the UI
                if (response.animalNames) {
                  // Update the order row text
                  const $orderRow = $(`.last-order-row[rel="${orderId}"]`);
                  const $textContainer = $orderRow.find(".animal_name");
                  // Update the text while preserving the span structure
                  $textContainer.html(`${response.animalNames}`);
                }
              } else if (isInCart) {
                // Handle cart page updates
                console.log("Cart animal assignments updated successfully");
                // You might want to update some UI elements on the cart page here
                if (response.message) {
                  // Show success message or update cart totals if needed
                  console.log(response.message);
                }
              }
            } else {
              console.error(
                "Error in bulk update:",
                response.error || "Unknown error"
              );
            }

            // Remove the request from the tracking map
            delete animalFoodRequests[requestKey];

            // Hide loader when done
            $loader.removeClass("d-flex").addClass("d-none");
          },
          error: function (xhr, status, error) {
            console.error("Error in bulk update request:", error);

            // Remove the request from the tracking map
            delete animalFoodRequests[requestKey];

            $loader.removeClass("d-flex").addClass("d-none");
          },
        });
      }, 50); // Small delay to collect all changes
    });

    // Remove the save functionality from the offcanvas close handler
    $(SELECTORS.offcanvasOrder).on("hidden.bs.offcanvas", (event) => {
      // Just destroy select2 safely
      safelyDestroySelect2(".animal-select-order");
    });

    // Add event listener for when animal form offcanvas is shown
    $(SELECTORS.offcanvasAnimal).on("shown.bs.offcanvas", function (event) {
      // Ensure health issues Select2 is initialized when the offcanvas is shown
      setTimeout(() => {
        initializeHealthIssuesSelect2(SELECTORS.offcanvasAnimal);
      }, 100);
    });

    // Add event listener for when animal form modal is shown
    $(SELECTORS.modalAddAnimal).on("shown.bs.modal", function (event) {
      // Ensure health issues Select2 is initialized when the modal is shown
      setTimeout(() => {
        initializeHealthIssuesSelect2(
          SELECTORS.modalAddAnimal + " .modal-body"
        );
      }, 100);
    });

    // Unified function to initialize health issues Select2
    function initializeHealthIssuesSelect2(context = "body") {
      if ($(SELECTORS.healthIssues).length > 0) {
        const $element = $(SELECTORS.healthIssues);
        // Destroy existing Select2 if any
        if ($element.hasClass("select2-hidden-accessible")) {
          $element.select2("destroy");
        }
        // Initialize Select2
        try {
          $element.select2({
            placeholder: "Ajouter une maladie",
            dropdownPosition: "below",
            //allowClear: true,
            width: "80%",
            //dropdownParent: $(context),
            matcher: function (params, item) {
              const currentSelections = $element.select2("data");

              // Exclude the item if it matches one of the current selections.
              if (
                currentSelections.find((selection) => selection.id === item.id)
              ) {
                return null;
              }

              // If no search term, or the item matches the search term, return the item.
              if (
                !params.term ||
                params.term.trim() === "" ||
                item.text.indexOf(params.term) > -1
              ) {
                return item;
              }

              // The item doesn't match the search term, so exclude it.
              return null;
            },
          });
          const eventNamespace = ".healthTrigger";
          $(document)
            .off("click" + eventNamespace) // Nettoyer les anciens gestionnaires pour éviter les exécutions multiples.
            .on(
              "click" + eventNamespace,
              ".health-issue-select-trigger-btn",
              function (e) {
                e.preventDefault();
                e.stopPropagation();
                // Cible statique car on assume un seul ID 'health_issues' à la fois dans le DOM.
                $(SELECTORS.healthIssues).select2("open");
              }
            );
        } catch (error) {
          console.error("Error initializing health issues Select2:", error);
        }
      }
    }

    // Initialize Components
    function initializeComponents() {
      // Initialize Datepicker
      $(SELECTORS.birthDate)
        .datepicker("destroy")
        .datepicker({
          maxDate: new Date(),
          language: "fr",
          dateFormat: "dd/mm/yyyy",
          autoClose: true,
          position: "bottom left",
          classes: "birth-date-picker",
          inline: false,
          keyboardNav: false, // Disable keyboard navigation
          onShow: (dp, animationCompleted) => {
            if (!animationCompleted) {
              $(".datepicker").css("z-index", 3000);
            }
          },
        })
        // Prevent typing and pasting
        .on("keydown paste", function (e) {
          e.preventDefault();
          return false;
        });

      // Update CSS styles
      const style = document.createElement("style");
      style.textContent = `
  .datepicker { z-index: 3000 !important; }
  .datepicker-inline { display: none !important; }
  .form-control[readonly],
  .form-control[disabled],
  .form-select[disabled] {
      cursor: pointer !important; /* Change cursor to pointer for better UX */
  }
  /* Add these new styles */
  .birth-date-picker {
      user-select: none !important;
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
  }
  /* Make the input look clickable but not editable */
  input.birth-date-picker {
      cursor: pointer !important;
  }`;
      document.head.appendChild(style);

      // Override jQuery's on method to add passive listeners for wheel events
      const originalOn = $.fn.on;
      $.fn.on = function (types, selector, data, fn) {
        if (
          typeof types === "string" &&
          (types.indexOf("wheel") !== -1 || types.indexOf("mousewheel") !== -1)
        ) {
          // Convert arguments to array for easy manipulation
          const args = Array.prototype.slice.call(arguments);

          // Replace with DOM addEventListener for wheel events
          if (this.length > 0) {
            this.each(function () {
              const element = this;
              const eventTypes = types.split(" ");

              eventTypes.forEach(function (eventType) {
                if (eventType === "wheel" || eventType === "mousewheel") {
                  // Set up the handler based on argument pattern
                  let handler;
                  if (typeof selector === "function") {
                    handler = selector;
                  } else if (typeof data === "function") {
                    handler = data;
                  } else {
                    handler = fn;
                  }

                  if (typeof handler === "function") {
                    // Remove jQuery's handler for this event
                    $(element).off(eventType);

                    // Add native handler with passive option
                    element.addEventListener(
                      eventType,
                      function (e) {
                        // Call the original handler with proper context and arguments
                        handler.call(element, $.Event(e));
                      },
                      { passive: true }
                    );
                  }
                }
              });
            });

            // Remove wheel-related events from the types
            const newTypes = types
              .split(" ")
              .filter(function (type) {
                return type !== "wheel" && type !== "mousewheel";
              })
              .join(" ");

            // If there are remaining events, call original on method
            if (newTypes) {
              args[0] = newTypes;
              return originalOn.apply(this, args);
            }

            return this;
          }
        }

        // Default behavior for other events
        return originalOn.apply(this, arguments);
      };
    }

    // Global passive listeners default for touch/wheel (excluding Slick and opted-out elements)
    (function () {
      var supportsPassive = false;
      try {
        var opts = Object.defineProperty({}, "passive", {
          get: function () {
            supportsPassive = true;
          },
        });
        window.addEventListener("test-passive", function () {}, opts);
        window.removeEventListener("test-passive", function () {}, opts);
      } catch (e) {}

      if (!supportsPassive) return;

      var originalAddEventListener = EventTarget.prototype.addEventListener;
      EventTarget.prototype.addEventListener = function (
        type,
        listener,
        options
      ) {
        // Force passive:true pour touchstart (sauf opt-out explicite)
        if (type === "touchstart") {
          var targetEl = this && this.nodeType === 1 ? this : null;
          var optedOut = false;
          if (targetEl) {
            try {
              optedOut =
                (targetEl.getAttribute &&
                  targetEl.getAttribute("data-passive") === "false") ||
                (targetEl.hasAttribute &&
                  targetEl.hasAttribute("data-passive-false")) ||
                (typeof targetEl.closest === "function" &&
                  !!targetEl.closest(".no-passive"));
            } catch (err) {}
          }
          if (!optedOut) {
            if (options === undefined) {
              options = { passive: true };
            } else if (typeof options === "boolean") {
              options = { capture: options, passive: true };
            } else if (
              typeof options === "object" &&
              options.passive === undefined
            ) {
              options.passive = true;
            }
          }
        } else if (type === "touchmove" || type === "wheel") {
          var target = this;
          var shouldForcePassive = true;
          if (target && target.nodeType === 1) {
            var el = target;
            try {
              if (
                (el.getAttribute &&
                  el.getAttribute("data-passive") === "false") ||
                (el.hasAttribute && el.hasAttribute("data-passive-false")) ||
                (typeof el.closest === "function" &&
                  !!el.closest(".no-passive"))
              ) {
                shouldForcePassive = false;
              }
            } catch (err) {}
          }
          if (shouldForcePassive) {
            if (options === undefined) {
              options = { passive: true };
            } else if (typeof options === "boolean") {
              options = { capture: options, passive: true };
            } else if (
              typeof options === "object" &&
              options.passive === undefined
            ) {
              options.passive = true;
            }
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    })();

    // Style global pour éliminer le caractère "scroll-blocking" des sliders verticaux
    (function () {
      try {
        var css =
          ".slick-slider.slick-vertical, .slick-vertical .slick-list, .header-infos .slick-list, .header-notifications " +
          ".slick-list{touch-action: none; -ms-touch-action: none;}";
        var style = document.createElement("style");
        style.textContent = css;
        document.head.appendChild(style);
      } catch (e) {}
    })();

    function startsWithVowel(name) {
      return /^[aeiouAEIOU]/.test(name);
    }

    // Function to update all animal selects with a newly created animal
    function updateAnimalSelectsWithNewAnimal(animalId, animalName) {
      // Find all animal select elements (both visible and hidden)
      const $animalSelects = $(".animal-select-order");

      $animalSelects.each(function () {
        const $select = $(this);

        // Check if this animal option already exists
        if ($select.find(`option[value="${animalId}"]`).length === 0) {
          // Create the new option element
          const $newOption = $("<option></option>")
            .attr("value", animalId)
            .text(animalName);

          // Find the "add_new" option and insert the new animal option before it
          const $addNewOption = $select.find('option[value="add_new"]');
          if ($addNewOption.length > 0) {
            $addNewOption.before($newOption);
          } else {
            // If no "add_new" option found, just append to the end
            $select.append($newOption);
          }

          // If Select2 is initialized on this element, trigger change to update the UI
          if (isSelect2Initialized($select)) {
            $select.trigger("change.select2");
          }
        }
      });

      // Also update the global animals data if it exists
      if (window.initialAnimalsData) {
        // Check if this animal is not already in the data
        const existingAnimal = window.initialAnimalsData.find(
          (animal) => animal.id == animalId
        );
        if (!existingAnimal) {
          window.initialAnimalsData.push({
            id: animalId,
            name: animalName,
          });
        }
      }
    }

    // Function to check if Select2 is initialized on an element
    function isSelect2Initialized($element) {
      return (
        $element.hasClass("select2-hidden-accessible") &&
        $element.data("select2") !== undefined &&
        typeof $element.select2 === "function"
      );
    }

    // Function to clean up orphaned Select2 elements
    function cleanupOrphanedSelect2Elements() {
      // Remove any orphaned select2 containers
      $(".select2-container").each(function () {
        const $container = $(this);
        const selectId = $container.attr("id");
        if (selectId) {
          const originalSelectId = selectId
            .replace("select2-", "")
            .replace("-container", "");
          const $originalSelect = $("#" + originalSelectId);
          if (
            $originalSelect.length === 0 ||
            !isSelect2Initialized($originalSelect)
          ) {
            $container.remove();
          }
        }
      });
    }

    // Function to safely destroy Select2
    function safelyDestroySelect2(selector) {
      $(selector).each(function () {
        const $element = $(this);

        // Force cleanup regardless of initialized state
        try {
          // Remove any event listeners first
          $element.off(
            "select2:unselecting select2:opening select2:open select2:close select2:select select2:unselect"
          );

          // If it has the select2 class, try to destroy
          if ($element.hasClass("select2-hidden-accessible")) {
            $element.select2("destroy");
          }

          // Force remove classes and data
          $element.removeClass("select2-hidden-accessible");
          $element.removeData("select2");
          $element.next(".select2-container").remove();

          console.log(
            "Select2 destroyed successfully for element:",
            $element[0]
          );
        } catch (e) {
          console.warn("Error destroying Select2:", e);
          // Force cleanup even if destroy fails
          $element.removeClass("select2-hidden-accessible");
          $element.removeData("select2");
          $element.next(".select2-container").remove();
          $element.off(
            "select2:unselecting select2:opening select2:open select2:close select2:select select2:unselect"
          );
        }
      });

      // Additional cleanup - remove any orphaned containers
      setTimeout(() => {
        cleanupOrphanedSelect2Elements();
      }, 10);
    }

    // Function to initialize Select2 on animal select elements
    function initializeAnimalSelect2(callback, container = null) {
      // Determine the container - either specified container, offcanvas, or document
      let $container;
      if (container) {
        $container = $(container);
      } else if (
        $(SELECTORS.offcanvasOrder).length &&
        $(SELECTORS.offcanvasOrder).hasClass("show")
      ) {
        $container = $(SELECTORS.offcanvasOrder);
      } else {
        $container = $(document);
      }

      // Show existing loaders and hide select elements during initialization
      $container.find(".animal-select-order").hide();
      $container.find(".animal-select-order-loader").show();

      // First, clean up ALL existing Select2 instances more aggressively
      $(".select2-container").remove();
      $(".animal-select-order")
        .removeClass("select2-hidden-accessible")
        .removeData("select2");

      // Then, safely destroy any remaining Select2 instances
      safelyDestroySelect2(".animal-select-order");

      // Wait a moment for cleanup to complete
      setTimeout(() => {
        // Target ALL select elements in the container (not just visible since we hid them)
        const $allSelects = $container.find(".animal-select-order");

        let initializationCount = 0;
        const totalSelects = $allSelects.length;

        // Function to check if all Select2 are initialized
        const checkInitializationComplete = () => {
          initializationCount++;
          if (initializationCount >= totalSelects) {
            // Simple flow: hide loaders and show select elements immediately
            setTimeout(() => {
              $container.find(".animal-select-order-loader").hide();
              $container.find(".animal-select-order").show();

              // Execute callback if provided
              if (typeof callback === "function") {
                callback();
              }
            }, 100);
          }
        };

        // If no selects to initialize
        if (totalSelects === 0) {
          // Simple flow: hide loaders immediately
          $container.find(".animal-select-order-loader").hide();
          $container.find(".animal-select-order").show();

          if (typeof callback === "function") {
            callback();
          }
          return;
        }

        $allSelects.each(function (index) {
          const $element = $(this);

          // Skip if Select2 is already initialized
          if (isSelect2Initialized($element)) {
            checkInitializationComplete();
            return;
          }

          // Temporarily show element for initialization (it's hidden for loader)
          const wasHidden = $element.is(":hidden");
          $element.show();

          // Ensure the element is in the DOM
          if (!$.contains(document, $element[0])) {
            // Restore hidden state if it was hidden
            if (wasHidden) $element.hide();
            checkInitializationComplete();
            return;
          }

          try {
            const $thisSelect = $element;
            const triggerButtonId = $thisSelect.attr("id") + "-trigger";

            // Select the whole button and its parts for robust handling
            const $triggerButton = $("#" + triggerButtonId);
            const $triggerButtonText = $triggerButton.find("span");
            const $triggerButtonIcon = $triggerButton.find("i, svg"); // Handle both i and svg for FontAwesome

            // If button doesn't exist, we can't proceed.
            if (!$triggerButton.length) {
              return;
            }

            // Determine placeholder based on available options
            const $options = $element.find('option[value!=""]'); // All non-empty options
            const $animalOptions = $options.filter('[value!="add_new"]'); // Options that are not add_new
            const placeholder =
              $animalOptions.length > 0
                ? "Sélectionner un animal"
                : "Ajouter un animal";

            // Determine dropdown parent
            const isInOffcanvas =
              $element.closest(SELECTORS.offcanvasOrder).length > 0;
            const dropdownParent = isInOffcanvas
              ? $(SELECTORS.offcanvasOrder)
              : $("body");

            $element
              .select2({
                placeholder: placeholder,
                dropdownPosition: "below",
                dropdownParent: dropdownParent,
                width: "100%",
                matcher: function (params, item) {
                  const currentSelections = $element.select2("data");

                  // Exclude the item if it matches one of the current selections.
                  if (
                    currentSelections.find(
                      (selection) => selection.id === item.id
                    )
                  ) {
                    return null;
                  }

                  // If no search term, or the item matches the search term, return the item.
                  if (
                    !params.term ||
                    params.term.trim() === "" ||
                    item.text.indexOf(params.term) > -1
                  ) {
                    return item;
                  }

                  // The item doesn't match the search term, so exclude it.
                  return null;
                },
                templateResult: function (data) {
                  // Safety check
                  if (!data || !data.element) {
                    return data ? data.text : "";
                  }
                  // Special handling for add_new option
                  if (data.id === "add_new") {
                    return data.text;
                  }
                  // Check if the option is disabled
                  if ($(data.element).prop("disabled")) {
                    setTimeout(function () {
                      $(
                        ".select2-results__option[aria-disabled=true]"
                      ).addClass("d-none");
                    }, 0);
                    return data.text;
                  }
                  return data.text;
                },
                templateSelection: function (data, container) {
                  // Safety check
                  if (!data || !data.element) {
                    return data ? data.text : "";
                  }
                  // Special handling for add_new option
                  if (data.id === "add_new") {
                    return data.text;
                  }
                  // Check if the option is disabled in the original select
                  var option = $(data.element);
                  if (option.prop("disabled")) {
                    $(container).addClass("disabled d-none");
                    setTimeout(function () {
                      $('.select2-selection__choice[title="' + data.text + '"]')
                        .find(".select2-selection__choice__remove")
                        .addClass("disabled");
                    }, 0);
                  }
                  return data.text;
                },
              })
              .on("select2:unselecting", function (e) {
                if (!e.params || !e.params.args || !e.params.args.data) {
                  return;
                }
                if (e.params.args.data.id === "add_new") {
                  return;
                }
                var option = $(e.params.args.data.element);
                if (option.prop("disabled")) {
                  e.preventDefault();
                } else {
                  $(this).data("unselecting", true);
                }
              })
              .on("select2:opening", function (e) {
                if ($(this).data("unselecting")) {
                  $(this).removeData("unselecting");
                  e.preventDefault();
                }
              });

            // Hide the loader now that Select2 is initialized
            const $loader = $thisSelect
              .closest(".animal-selection-wrapper")
              .find(".animal-select-order-loader");
            $loader.removeClass("d-flex").addClass("d-none");

            // START: Custom logic for trigger button
            const updateTriggerButtonVisibility = () => {
              const $wrapper = $thisSelect.closest(".animal-selection-wrapper");
              const selectedValues = $thisSelect.val() || [];
              const selectedCount = selectedValues.filter(
                (v) => v && v !== "add_new"
              ).length;
              const totalAnimalOptions = $thisSelect.find(
                'option[value!=""][value!="add_new"]:not(:disabled):not(.d-none)'
              ).length;

              if (selectedCount === 0) {
                $wrapper.removeClass("selection-active");
              } else {
                $wrapper.addClass("selection-active");
                if (
                  totalAnimalOptions > 0 &&
                  selectedCount >= totalAnimalOptions
                ) {
                  $triggerButtonText.text("Ajouter un animal");
                  $triggerButtonIcon.addClass("d-none");
                } else {
                  $triggerButtonText.text("Sélectionner un animal");
                  $triggerButtonIcon.removeClass("d-none");
                }
              }
            };

            const eventNamespace = "click.trigger." + triggerButtonId;
            // Use a namespaced, delegated event to prevent duplicates.
            // First, remove any previous listener with this exact namespace.
            $(document).off(eventNamespace);
            // Then, attach the new one.
            $(document).on(eventNamespace, "#" + triggerButtonId, function (e) {
              e.preventDefault();
              e.stopPropagation();

              if ($triggerButtonText.text().trim() === "Ajouter un animal") {
                if ($thisSelect.data("select2").isOpen()) {
                  $thisSelect.select2("close");
                }
                let currentValues = $thisSelect.val() || [];
                if (!currentValues.includes("add_new")) {
                  currentValues.push("add_new");
                }
                $thisSelect.val(currentValues).trigger("change");
              } else {
                if ($thisSelect.data("select2").isOpen()) {
                  $thisSelect.select2("close");
                } else {
                  // Defer the open action to the next event cycle to avoid offcanvas focus trap
                  const $select2Container = $thisSelect
                    .closest(".animal-select-order-wrapper")
                    .find(".select2-container");
                  if ($select2Container.length) {
                    $select2Container
                      .find(".select2-selection")
                      .trigger("click");
                  }
                }
              }
            });

            $thisSelect.on("change", function () {
              const selectedValues = $(this).val() || [];
              if (selectedValues.includes("add_new")) {
                return;
              }
              updateTriggerButtonVisibility();
            });

            // Initial state check
            setTimeout(() => {
              updateTriggerButtonVisibility();
            }, 0);
            // END: Custom logic for trigger button

            // Restore hidden state if it was hidden
            if (wasHidden) $element.hide();

            // Mark this select as initialized
            checkInitializationComplete();
          } catch (error) {
            console.error("Select 0: Error initializing Select2:", error);
            checkInitializationComplete();
          }
        });
      }, 100); // Increased delay to ensure cleanup is complete
    }

    // Function to initialize Select2 on cart page

    function initializeCartAnimalSelects() {
      // Check if we're on a page with cart functionality
      if ($(".animal-select-order").length > 0) {
        // Show loaders while initializing
        $(".animal-select-order-loader").show();

        // Simple initialization - the HTML is already pre-populated by server
        initializeAnimalSelect2(function () {
          // Hide loaders and let Select2 containers show naturally
          $(".animal-select-order-loader").hide();
        });
      }
    }
    // Initialize cart animal selects if they exist
    initializeCartAnimalSelects();

    // Event Handlers
    function initializeEventHandlers() {
      // Form submission
      $(document).on("submit", SELECTORS.form, function (e) {
        e.preventDefault();
        utils.removeWarningMessages();
        const validation = utils.validateForm();
        if (!validation.isValid) {
          $(this).prepend(validation.messages);
          return false;
        }

        const form = $(this);
        const isUpdate = form.data("animal-id");

        // Detect context: offcanvas vs modal
        const isInModal = form.closest(".modal").length > 0;
        let formData = {};

        if (isUpdate) {
          // Update operation: only include health_issues and neutered
          formData = {
            animal_profile: 1,
            animal_id: isUpdate,
            health_issues: $(SELECTORS.healthIssues).val(),
            neutered: $(SELECTORS.neutered).val(),
            is_dead: $(SELECTORS.form).find('input[name="is_dead"]').val() || 0, // Get the value from the hidden input
            ajax: 1,
          };
        } else {
          // Creation operation: include all fields
          formData = {
            animal_profile: 1,
            name: $(SELECTORS.petName).val(),
            sex: $(SELECTORS.gender + ":checked").val(),
            birthday: $(SELECTORS.birthDate).val(),
            animal_type: $(SELECTORS.animalType + ":checked").val(),
            health_issues: $(SELECTORS.healthIssues).val(),
            neutered: $(SELECTORS.neutered).val(),
            breed: null,
            ajax: 1,
          };
          const animalType = formData.animal_type;
          formData.breed = $(`#${animalType}_breed`).val();
        }

        const url =
          window.location.protocol +
          "//" +
          window.location.hostname +
          "/account/dashboard/";
        $(SELECTORS.loaderForm).show();
        $.ajax({
          url: url,
          data: formData,
          dataType: "json",
          type: "POST",
          success: function (response) {
            if (response.success) {
              const isDead = formData.is_dead === "1";
              const successMessage = isDead
                ? `
              <div class="bg-info p-3 text-white fw-bold text-center">
                Nous sommes désolés pour la perte de votre animal, nos pensées vous accompagnent.
                <br>Si vous avez des abonnements en cours, veuillez les suspendre sur la page
                <a href="${window.location.protocol}//${window.location.hostname}/account/subscription/" class="link-white">Mes abonnements</a>.
              </div>
            `
                : `
              <div class="bg-success p-3 text-white fw-bold text-center">
                Profil de votre animal ${
                  isUpdate ? "modifié" : "ajouté"
                } avec succès !
              </div>
            `;
              $(SELECTORS.loaderForm).hide();
              $(SELECTORS.form).find('input[name="is_dead"]').remove();
              $(SELECTORS.ownerNotification).html(successMessage).show();

              // Close the appropriate panel/modal based on context
              if (isInModal) {
                $(SELECTORS.modalAddAnimal).modal("hide");
              } else {
                $(SELECTORS.offcanvasAnimal).offcanvas("hide");
                // Always refresh the animals block
                utils.refreshAnimalsBlock();
                if (isDead) {
                  // If an animal was marked as dead, also refresh the orders table
                  utils.refreshLastOrdersTable();
                  // Also refresh the order datatable if we're on the order page
                  utils.refreshOrderTable();
                }
              }

              // If a new animal was created (not an update and not marked as dead), update all animal selects
              if (!isUpdate && !isDead && response.id) {
                updateAnimalSelectsWithNewAnimal(response.id, formData.name);

                // If we came from the order panel, reopen it after a short delay
                if (cameFromOrderPanel && lastOrderPanelData) {
                  setTimeout(() => {
                    // Restore the order panel content
                    $(`${SELECTORS.offcanvasOrder} .panel-header h2`).html(
                      lastOrderPanelData.header
                    );
                    $(`${SELECTORS.offcanvasOrder} .panel-body`).html(
                      lastOrderPanelData.body
                    );

                    // Update the HTML content with the new animal option
                    $(
                      `${SELECTORS.offcanvasOrder} .panel-body .animal-select-order`
                    ).each(function () {
                      const $select = $(this);

                      // Check if this animal option already exists
                      if (
                        $select.find(`option[value="${response.id}"]`)
                          .length === 0
                      ) {
                        // Create the new option element
                        const $newOption = $("<option></option>")
                          .attr("value", response.id)
                          .text(formData.name);

                        // Find the "add_new" option and insert the new animal option before it
                        const $addNewOption = $select.find(
                          'option[value="add_new"]'
                        );
                        if ($addNewOption.length > 0) {
                          $addNewOption.before($newOption);
                        } else {
                          // If no "add_new" option found, just append to the end
                          $select.append($newOption);
                        }
                      }
                    });

                    // Initialize Select2 first, then show the panel when ready
                    console.log("Initializing Select2 for order panel...");

                    // Force cleanup of any existing Select2 instances
                    safelyDestroySelect2(".animal-select-order");
                    cleanupOrphanedSelect2Elements();

                    // Initialize Select2 and show panel when done
                    initializeAnimalSelect2(() => {
                      // Callback function executed when Select2 initialization is complete
                      console.log(
                        "Select2 initialization complete for order panel"
                      );

                      // Hide all loaders that might still be visible
                      $(".animal-select-order-loader")
                        .removeClass("d-flex")
                        .addClass("d-none");

                      // Auto-select the new animal in the source Select2 if we have the info
                      if (sourceSelect2Info && response.id) {
                        const $sourceSelect = $(
                          `${SELECTORS.offcanvasOrder} .animal-select-order[data-order-id="${sourceSelect2Info.orderId}"][data-item-id="${sourceSelect2Info.productId}"]`
                        );

                        if ($sourceSelect.length) {
                          console.log(
                            "Auto-selecting new animal in source Select2:",
                            {
                              animalId: response.id,
                              animalName: formData.name,
                              sourceSelect: $sourceSelect[0],
                            }
                          );

                          // Get current selections and add the new animal
                          const newSelections = [
                            ...sourceSelect2Info.currentSelections,
                            response.id.toString(),
                          ];

                          // Set the new selections
                          $sourceSelect.val(newSelections);

                          // Trigger the change event to update the UI and save the data
                          $sourceSelect.trigger("change");

                          console.log("New animal auto-selected successfully");
                        } else {
                          console.warn(
                            "Source Select2 not found:",
                            sourceSelect2Info
                          );
                        }

                        // Clear the source info after use
                        sourceSelect2Info = null;
                      }

                      // Now show the order panel
                      $(SELECTORS.offcanvasOrder).offcanvas("show");

                      // Reset the tracking variables
                      cameFromOrderPanel = false;
                      lastOrderPanelData = null;
                    });
                  }, 500); // Small delay to ensure the animal panel is fully closed
                }

                // If we came from a cart Select2, handle modal closure and update the Select2
                if (cameFromCartSelect2 && cartSelect2Info) {
                  setTimeout(() => {
                    // Close the modal
                    $(SELECTORS.modalAddAnimal).modal("hide");

                    // Auto-select the new animal in the cart Select2
                    if (cartSelect2Info.selectElement && response.id) {
                      console.log(
                        "Auto-selecting new animal in cart Select2:",
                        {
                          animalId: response.id,
                          animalName: formData.name,
                          productId: cartSelect2Info.productId,
                        }
                      );

                      // Get current selections and add the new animal
                      const newSelections = [
                        ...cartSelect2Info.currentSelections,
                        response.id.toString(),
                      ];

                      // Set the new selections
                      cartSelect2Info.selectElement.val(newSelections);

                      // Trigger the change event to update the UI and save to session
                      cartSelect2Info.selectElement.trigger("change");

                      console.log(
                        "New animal auto-selected in cart successfully"
                      );
                    }

                    // Reset the tracking variables
                    cameFromCartSelect2 = false;
                    cartSelect2Info = null;
                  }, 300); // Small delay to ensure the modal is closing
                }
              }

              setTimeout(() => {
                $(SELECTORS.ownerNotification).fadeOut().html("");
              }, 15000);
            }
          },
          error: function (xhr, status, error) {
            console.error("Error:", error);
            const errorMessage = `
              <div class="bg-warning p-3 text-white fw-bold text-center">
                 Une erreur est survenue. Veuillez réessayer.
              </div>
            `;
            $(SELECTORS.loaderForm).hide();
            $(SELECTORS.ownerNotification).html(errorMessage).show();

            // Close the appropriate panel/modal based on context
            if (isInModal) {
              $(SELECTORS.modalAddAnimal).modal("hide");
            } else {
              $(SELECTORS.offcanvasAnimal).offcanvas("hide");
              utils.refreshAnimalsBlock();
              setTimeout(() => {
                $(SELECTORS.ownerNotification).fadeOut().html("");
              }, 15000);
            }
          },
        });
      });

      // Mark as dead button click handler
      $(document).on("click", ".mark-as-dead", function (e) {
        e.preventDefault();
        const form = $(SELECTORS.form);
        const animalName = $(SELECTORS.petName).val();
        const $button = $(this);

        // If button already has btn-danger class, it's the confirmation click
        if ($button.hasClass("btn-danger")) {
          // Check if the is_dead field already exists
          if (form.find('input[name="is_dead"]').length) {
            // Update existing input value
            form.find('input[name="is_dead"]').val("1");
          } else {
            // Create new input if it doesn't exist
            form.append('<input type="hidden" name="is_dead" value="1">');
          }

          // Submit the form - the form submit handler will take care of the rest
          form.trigger("submit");
          return;
        }

        // First click - Replace the button text with a confirmation message
        const originalText = $button.text();
        $button.html(`Confirmer le décès de ${animalName}`);
        $button
          .addClass("btn-danger text-white")
          .removeClass("btn-gray text-dark");

        // Add a cancel button if it doesn't exist
        if (!$button.siblings(".cancel-death-confirmation").length) {
          $button.after(
            `<button class="btn btn-light w-100 rounded-1 fw-bold btn-sm py-2 text-dark mb-3 cancel-death-confirmation">Annuler</button>`
          );
        }

        // Switch from confirmation back to normal state
        $(document).on("click", ".cancel-death-confirmation", function () {
          $button.html(originalText);
          $button
            .removeClass("btn-danger text-white")
            .addClass("btn-gray text-dark");
          $(this).remove();
        });
      });

      $(document).on(
        "click",
        ".animal-type-selection .type-option label",
        function (e) {
          e.preventDefault();
          // Get the radio input and its value
          const radio = $(this).find('input[type="radio"]');
          const animalType = radio.val();
          // Update radio buttons
          $('input[name="animal_type"]').prop("checked", false);
          radio.prop("checked", true);
          // Update UI
          $(".type-option label").removeClass("active");
          $(this).addClass("active");
          // Hide all breed groups first
          $('[class*="_breed_group"]').hide();
          $(".breed_select").prop("required", false);
          if (animalType) {
            $(`.${animalType}_breed_group`).show();
            $(`#${animalType}_breed`).prop("required", true);
          }
        }
      );

      // Handle animal line click
      $(document).on("click", ".animal-line", function (e) {
        e.preventDefault();
        formHandlers.loadAnimalDetails($(this));
        zE("messenger:set", "zIndex", -1);
        zE("messenger", "close");
      });

      // Handle add animal button click
      $(document).on("click", ".add-animal-btn", function (e) {
        e.preventDefault();
        formHandlers.resetForm();
        zE("messenger:set", "zIndex", -1);
        zE("messenger", "close");
      });
    }

    // Robust AJAX complete handler for cart updates
    $(document).ajaxComplete(function (event, xhr, settings) {
      // More precise cart detection using regex and specific patterns
      const isCartRelated =
        settings.url &&
        // WooCommerce cart pages (multilingual support) - exact path matching
        (/\/cart\/?(\?|$)/.test(settings.url) ||
          /\/panier\/?(\?|$)/.test(settings.url) ||
          // WooCommerce AJAX endpoints
          settings.url.includes("wc-ajax=") ||
          // Cart form submissions - check for specific cart actions
          (settings.type === "POST" &&
            settings.data &&
            (settings.data.includes("update_cart") ||
              settings.data.includes("apply_coupon") ||
              settings.data.includes("remove_coupon") ||
              settings.data.includes("cart[")))); // Cart quantity updates

      if (isCartRelated) {
        // Skip our own AJAX calls
        const isOurCall =
          settings.data &&
          settings.data.includes("store_cart_animal_assignments");

        // Only proceed if it's not our call and the request was successful
        if (!isOurCall && xhr.status === 200) {
          console.log("🎯 WooCommerce cart updated successfully");

          // Use requestAnimationFrame for better timing than setTimeout
          // This ensures DOM updates are complete before we reinitialize
          requestAnimationFrame(() => {
            // Double-check that we're still on a cart page and have selects
            if (
              $("body").hasClass("woocommerce-cart") &&
              $(".animal-select-order").length > 0
            ) {
              console.log("🔄 Reinitializing Select2 on updated cart");
              initializeCartAnimalSelects();
            }
          });
        }
      }
    });

    initializeComponents();
    initializeEventHandlers();

    function checkWindowHeight() {
      console.log("checkWindowHeight");
      if ($(window).height() < 700 && $(window).width() < 540) {
        $(".header-infos").hide();
        $(".header.sticky-top").addClass("no-header-infos");
        $(".header-top .htitle").addClass("no-header-infos");
      } else {
        $(".header-infos").show();
        $(".header.sticky-top").removeClass("no-header-infos");
        $(".header-top .htitle").removeClass("no-header-infos");
      }
    }

    // Run on page load
    checkWindowHeight();

    // Run on window resize
    $(window).resize(function () {
      checkWindowHeight();
    });

    if ($(".header-notifications").length > 0) {
      var notif = document.querySelector(".header-notifications");
      var nav = document.querySelector(".navbar.fixed-top");
      if (!notif || !nav) {
        window.setFixedTopPosition = function () {};
      } else {
        function applyTop() {
          if (!notif || (notif.offsetHeight || 0) === 0) {
            nav.style.top = "0px";
            return;
          }
          var rect = notif.getBoundingClientRect() || {};
          var bottom = rect.bottom || 0;
          var newTop = bottom > 0 ? bottom : 0; // recalcul continu tant que > 0
          nav.style.top = newTop + "px";
        }

        // Expose API globale pour compatibilité (Slick etc.)
        window.setFixedTopPosition = applyTop;

        // Initial
        applyTop();

        // Scroll: recalcul en continu pendant la visibilité des notifications
        var __scrollTicking = false;
        function scheduleApplyIfVisible() {
          var n = document.querySelector(".header-notifications");
          if (!n || (n.offsetHeight || 0) === 0) {
            nav.style.top = "0px";
            __scrollTicking = false;
            return;
          }
          notif = n;
          var rect = notif.getBoundingClientRect() || {};
          if ((rect.bottom || 0) <= 0) {
            // Complètement hors écran: garantir top=0 et ne pas planifier
            if (nav.style.top !== "0px") nav.style.top = "0px";
            __scrollTicking = false;
            return;
          }
          if (__scrollTicking) return;
          __scrollTicking = true;
          requestAnimationFrame(function () {
            applyTop();
            __scrollTicking = false;
          });
        }

        // Suivi en continu au scroll
        window.addEventListener("scroll", scheduleApplyIfVisible, {
          passive: true,
        });

        // Toujours corriger au resize (changement de layout/hauteur)
        window.addEventListener("resize", applyTop);

        // Forcer la mise à jour immédiate lors de la fermeture d'une alerte
        $(document).on(
          "click",
          ".header-notifications .btn-close",
          function () {
            setTimeout(function () {
              var n = document.querySelector(".header-notifications");
              if (!n || (n.offsetHeight || 0) === 0) {
                nav.style.top = "0px";
              } else {
                notif = n;
                applyTop();
              }
            }, 0);
          }
        );
      }
    }

    // Fallback global devenu inutile: setFixedTopPosition est toujours défini ci-dessus
    //////////////////////
    //// Slick carousel //
    ////// Scripts ///////
    //////////////////////
    if ($.fn.slick) {
      (function () {
        var $sliders = $(".header-slider-infos,.header-slider-notifications");
        if ($sliders.length) {
          // IMPORTANT: éviter d'initialiser slick sur un élément display:none
          var $containers = $(".header-infos,.header-notifications");
          // Affiche le conteneur sans le rendre visible pour le calcul des dimensions par Slick
          $containers.removeClass("d-none").css("visibility", "hidden");

          function adjustSlickHeights($s) {
            // Attendre le prochain frame pour garantir le layout de Slick
            requestAnimationFrame(function () {
              var $slides = $s.find(".slick-slide");
              // Reset avant mesure (largeur change => nombre de lignes change)
              $slides.css({ height: "", display: "block" });
              $s.find(".slick-list, .slick-track").css({ height: "" });
              $containers.css({ minHeight: "" });
              var maxH = 0;
              $slides.each(function () {
                var h = $(this).outerHeight(true) || 0;
                if (h > maxH) maxH = h;
              });
              if (maxH > 0) {
                // Forcer une hauteur unique pour tous les slides et remonter la hauteur jusqu'au parent
                $slides.css({ display: "block", height: maxH + "px" });
                $s.find(".slick-list, .slick-track").css({
                  height: maxH + "px",
                });
              }
              // Met à jour la navbar en fonction des notifications
              if (window.setFixedTopPosition) window.setFixedTopPosition();
            });
          }
          $sliders.on("init", function () {
            $containers.css("visibility", "visible");
          });
          $sliders.on("init setPosition afterChange", function () {
            adjustSlickHeights($(this));
          });

          $sliders.slick({
            vertical: true,
            slidesToShow: 1,
            autoplay: true,
            infinite: true,
            arrows: false,
            adaptiveHeight: false,
          });

          // Recalcul au resize/orientation change (debounce léger)
          var __slickResizeTimer;
          $(window).on("resize orientationchange", function () {
            clearTimeout(__slickResizeTimer);
            __slickResizeTimer = setTimeout(function () {
              $sliders.each(function () {
                var $s = $(this);
                if ($s.hasClass("slick-initialized")) {
                  $s.slick("setPosition");
                  adjustSlickHeights($s);
                }
              });
            }, 60);
          });
        }
      })();

      $(".slick_box")
        .on("init", function (event, slick) {
          $(this).css("display", "block");
        })
        .slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 0,
          infinite: true,
          autoplay: false,
          variableWidth: false,
          centerMode: false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });

      $(".retailer")
        .on("init", function (event, slick) {
          $(this).css("display", "block");
        })
        .slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          initialSlide: 0,
          autoplay: true,
          infinite: true,
          variableWidth: false,
          centerMode: false,
          lazyLoad: "progressive",
          arrows: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ],
        });

      $(".prod_showcase")
        .on("init", function (event, slick) {
          $(this).css("display", "block");
        })
        .slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 0,
          infinite: true,
          autoplay: false,
          variableWidth: false,
          centerMode: false,
          lazyLoad: "progressive",
          arrows: false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
              },
            },
          ],
        });
    }

    // Merged quantity update handler for both add and remove buttons
    $(document).on("click", ".add_ic, .remove_ic", function () {
      console.log("add_ic or remove_ic clicked");
      var isAdd = $(this).hasClass("add_ic");
      var $qtyInput = $(this).siblings(".qty_vetorino");
      var allowZero = $qtyInput.is('[data-allow-zero="1"]');
      var minQtyAttr = parseInt($qtyInput.attr("data-min-qty"), 10);
      var minAllowed = allowZero
        ? 0
        : Number.isInteger(minQtyAttr)
        ? minQtyAttr
        : 1;
      var currentQty = parseInt($qtyInput.val()) || 0;
      var newQty;

      if (isAdd) {
        newQty = currentQty + 1;
      } else {
        newQty = currentQty - 1;
        if (newQty < minAllowed) {
          $qtyInput.val(minAllowed);
          return;
        }
      }

      $qtyInput.val(newQty);

      // Common cart update logic (update cart button)
      setTimeout(() => {
        $(".woocommerce-cart .woocommerce-notices-wrapper div").remove();
        $("[name='update_cart']").removeAttr("disabled");
        $("[name='update_cart']").trigger("click");
        $("[name='update_cart']").attr("disabled", "disabled");
      }, 3000);
    });

    // Input: allow only numbers and remove leading zeros (for quantity input)
    $(document).on("input", ".qty_vetorino", function () {
      var val = this.value.replace(/[^0-9]/g, "");
      var allowZero = $(this).is('[data-allow-zero="1"]');
      var minQtyAttr = parseInt($(this).attr("data-min-qty"), 10);
      var minAllowed = allowZero
        ? 0
        : Number.isInteger(minQtyAttr)
        ? minQtyAttr
        : 1;
      if (val.length > 1) {
        val = val.replace(/^0+/, "");
      }
      if (minAllowed > 0 && val === "0") val = "";
      this.value = val;
    });

    // Blur: force a minimum of 1 (for quantity input)
    $(document).on("blur", ".qty_vetorino", function () {
      var allowZero = $(this).is('[data-allow-zero="1"]');
      var minQtyAttr = parseInt($(this).attr("data-min-qty"), 10);
      var minAllowed = allowZero
        ? 0
        : Number.isInteger(minQtyAttr)
        ? minQtyAttr
        : 1;
      var n = parseInt(this.value, 10);
      if (!this.value || n < minAllowed || !Number.isInteger(n)) {
        this.value = String(minAllowed);
      }
    });

    $(document).on("change", ".qty_vetorino", function () {
      var allowZero = $(this).is('[data-allow-zero="1"]');
      var minQtyAttr = parseInt($(this).attr("data-min-qty"), 10);
      var minAllowed = allowZero
        ? 0
        : Number.isInteger(minQtyAttr)
        ? minQtyAttr
        : 1;
      var qty = parseInt($(this).val());
      if (qty < minAllowed || !Number.isInteger(qty)) {
        $(this).val(minAllowed);
      }
      setTimeout(() => {
        $(".woocommerce-cart .woocommerce-notices-wrapper div").remove();
        $("[name='update_cart']").removeAttr("disabled");
        $("[name='update_cart']").trigger("click");
        $("[name='update_cart']").attr("disabled", "disabled");
      }, 3000);
    });

    $(".card-img-top.articleImage").each(function () {
      var $this = $(this);
      var imageUrl = $this.data("image");
      $this.css("backgroundImage", "url(" + imageUrl + ")");
      var img = new Image();
      img.onload = function () {
        $this.css("backgroundImage", "url(" + imageUrl + ")");
      };
      img.onerror = function () {
        $this.css(
          "backgroundImage",
          "url(" +
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/boutique/wp-content/uploads/woocommerce-placeholder.png)"
        );
      };
      img.src = imageUrl;
    });

    if ($(".navbar-custom").length > 0) {
      const pageHeader = document.querySelector(".navbar-custom");
      const toggleMenu = pageHeader.querySelector(".navbar-toggle");
      const closeButtons = document.querySelectorAll(".navbar-close");
      const menuWrapper = pageHeader.querySelector(".menu-wrapper");
      const level1Links = pageHeader.querySelectorAll(
        ".level-1 > li > .item-wrapper > .dropdown-toggle"
      );
      const listWrapper2 = pageHeader.querySelector(
        ".list-wrapper:nth-child(2)"
      );
      const listWrapper3 = pageHeader.querySelector(
        ".list-wrapper:nth-child(3)"
      );
      const subMenuWrapper2 = listWrapper2.querySelector(".sub-menu-wrapper");
      const subMenuWrapper3 = listWrapper3.querySelector(".sub-menu-wrapper");
      const backOneLevelBtns = pageHeader.querySelectorAll(".back-one-level");
      const backLabel2 = listWrapper2.querySelector(".back-one-level span");
      const backLabel3 = listWrapper3.querySelector(".back-one-level span");
      const isVisibleClass = "is-visible";
      const isActiveClass = "is-active";
      const pageHtml = document.querySelector("html");
      const isOpenClass = "menu-open";

      toggleMenu.addEventListener("click", function () {
        console.log("toggleMenu clicked");

        menuWrapper.classList.toggle(isVisibleClass);

        if (!menuWrapper.classList.contains(isVisibleClass)) {
          listWrapper2.classList.remove(isVisibleClass);
          listWrapper3.classList.remove(isVisibleClass);
          pageHtml.classList.remove(isOpenClass);

          const menuLinks = menuWrapper.querySelectorAll(
            "span[itemprop='name']"
          );
          for (const menuLink of menuLinks) {
            menuLink.classList.remove(isActiveClass);
          }
          backLabel2.textContent = "";
          backLabel3.textContent = "";
        } else {
          pageHtml.classList.add(isOpenClass);
        }
      });

      closeButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          pageHtml.classList.remove(isOpenClass);
          menuWrapper.classList.remove(isVisibleClass);
          listWrapper2.classList.remove(isVisibleClass);
          listWrapper3.classList.remove(isVisibleClass);
          const menuLinks = menuWrapper.querySelectorAll(
            "span[itemprop='name']"
          );
          for (const menuLink of menuLinks) {
            menuLink.classList.remove(isActiveClass);
          }
          backLabel2.textContent = "";
          backLabel3.textContent = "";
        });
        const dropdowns = document.querySelectorAll(
          "navbar-custom level-1 .dropdown"
        );
        dropdowns.forEach(function (dropdown) {
          dropdown.classList.remove("open");
        });
      });

      for (const dropdownToggle of level1Links) {
        dropdownToggle.addEventListener("click", function (e) {
          const itemWrapper = dropdownToggle.closest(".item-wrapper");
          const siblingList = itemWrapper.nextElementSibling;
          if (siblingList) {
            e.preventDefault();
            this.classList.add(isActiveClass);
            const cloneSiblingList = siblingList.cloneNode(true);
            cloneSiblingList.classList.remove("dropdown-menu");
            subMenuWrapper2.innerHTML = "";
            subMenuWrapper2.append(cloneSiblingList);
            listWrapper2.classList.add(isVisibleClass);
            const blockElement = cloneSiblingList.querySelector("li.block");
            if (blockElement) {
              const level1Icon = blockElement.querySelector(
                "span[itemprop='name']"
              );
              if (level1Icon) {
                backLabel2.textContent =
                  level1Icon.textContent +
                  " " +
                  itemWrapper.querySelector('span[itemprop="name"]')
                    .textContent;
                level1Icon.classList.add("d-none");
              }
            }
          }
        });
      }

      listWrapper2.addEventListener("click", function (e) {
        const target = e.target.closest(".dropdown-toggle");
        if (target) {
          const itemWrapper = target.closest(".item-wrapper");
          const siblingList = itemWrapper
            ? itemWrapper.nextElementSibling
            : null;
          if (siblingList) {
            e.preventDefault();
            itemWrapper.classList.add(isActiveClass);
            const cloneSiblingList = siblingList.cloneNode(true);
            subMenuWrapper3.innerHTML = "";
            subMenuWrapper3.append(cloneSiblingList);
            listWrapper3.classList.add(isVisibleClass);
            const spanElement = itemWrapper.querySelector('[itemprop="name"]');
            backLabel3.innerHTML =
              backLabel2.textContent + " / " + spanElement.textContent;
          }
        }
      });

      for (const backOneLevelBtn of backOneLevelBtns) {
        backOneLevelBtn.addEventListener("click", function () {
          const parent = this.closest(".list-wrapper");
          parent.classList.remove(isVisibleClass);
          parent.previousElementSibling
            .querySelector(".is-active")
            .classList.remove(isActiveClass);
        });
      }
    }

    $(window).on("scroll touchmove", function () {
      var winWidth = $(window).width();
      var scrollHeight = $(document).scrollTop();
      if (scrollHeight >= 120 && winWidth >= 992) {
        $(".profile-pic").addClass("profile-pic-small");
      } else {
        $(".profile-pic").removeClass("profile-pic-small");
      }
    });

    $(document).on("click", ".copy-text", function () {
      // Retrieve the product ID stored in data-product-id attribute
      var productID = $(this).data("product-id");

      // Use the Clipboard API to copy the text
      navigator.clipboard.writeText(productID.toString()).then(
        function () {
          console.log("Product ID copied to clipboard successfully!");
          //alert("Product ID copied: " + productID); // Optional: Show confirmation to the user
          setTimeout(function () {
            $("#copied_tip").remove();
          }, 800);
          $(".copy-text").append(
            "<div class='tip position-absolute' id='copied_tip'>Copié !</div>"
          );
        },
        function (err) {
          console.error("Error copying text: ", err);
        }
      );
    });

    function checkUserLoggedIn() {
      return new Promise((resolve, reject) => {
        console;

        var url =
          window.location.protocol +
          "//" +
          window.location.hostname +
          "/boutique/wp-admin/admin-ajax.php";
        jQuery.ajax({
          url: url,
          type: "POST",
          data: { action: "check_user_logged_in" },
          success: function (response) {
            if (response.success) {
              resolve(response.data);
            } else {
              reject("Erreur lors de la vérification de l'état de connexion.");
            }
          },
          error: function () {
            reject("Erreur de communication avec le serveur.");
          },
        });
      });
    }

    document.addEventListener("DOMContentLoaded", function () {
      checkUserLoggedIn()
        .then((userId) => {
          var loginButton = document.getElementById("login-button");
          // Only proceed if loginButton exists
          if (loginButton) {
            if (userId) {
              loginButton.setAttribute(
                "href",
                window.location.protocol +
                  "//" +
                  window.location.hostname +
                  "/" +
                  "account/dashboard"
              );
              loginButton.textContent = "Mon compte";
            } else {
              loginButton.setAttribute(
                "href",
                window.location.protocol +
                  "//" +
                  window.location.hostname +
                  "/" +
                  "pro/admin/login"
              );
              loginButton.textContent = "Connexion";
            }
          }
        })
        .catch((error) => {
          console.error("Error checking user login status:", error);
        });
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      const tooltipList = [...tooltipTriggerList].map(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
      );
    });
  });
});
